const updates = [
  {
    date: '07.29',
    title: '《我独自升级》外传篇正式上线',
    desc: '暗影君主归来！人气韩漫《我独自升级》外传篇今日同步上线，讲述主角觉醒后的全新冒险故事。',
    tag: '新作上线',
  },
  {
    date: '07.28',
    title: '《咒术回战》最新话高能更新',
    desc: '五条悟对战两面宿傩的终极对决迎来转折，本话战斗分镜堪称经典，不容错过。',
    tag: '热门更新',
  },
  {
    date: '07.27',
    title: '下拉式阅读功能全面优化',
    desc: '阅读体验升级！全站漫画支持更流畅的下拉式全集阅读模式，自动预加载下一话内容。',
    tag: '功能更新',
  },
  {
    date: '07.26',
    title: '国漫专区新增50部优质作品',
    desc: '本周国漫大全专区大幅扩展，《镇魂街》《一人之下》等人气国漫持续更新中。',
    tag: '资源扩充',
  },
  {
    date: '07.25',
    title: '《蓝色监狱》第二季动画预热专题',
    desc: '为迎接动画第二季播出，平台上线《蓝色监狱》漫画专属阅读专题，完整收录全部话数。',
    tag: '专题策划',
  },
  {
    date: '07.24',
    title: '恋爱漫画专题：夏日甜蜜推荐',
    desc: '夏季限定恋爱漫画推荐清单！精选多部高分恋爱甜宠韩漫和日漫，陪你度过浪漫夏日。',
    tag: '专题推荐',
  },
  {
    date: '07.23',
    title: '移动端阅读体验大幅提升',
    desc: '歪歪漫画网移动端界面全面优化，适配更多手机型号，纵横滑动更流畅，看漫画更舒心。',
    tag: '体验优化',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">更新快讯</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">平台最新动态与漫画更新资讯，第一时间掌握歪歪漫画网最新消息</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex gap-4 group cursor-pointer"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-16 text-right">
                  <span className="text-sm font-heading font-bold text-primary-500">{item.date}</span>
                </div>
                <div className="w-px flex-1 bg-background-300 mt-3 mb-1 group-last:bg-transparent"></div>
              </div>

              <div className={`flex-1 pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
                <div className="bg-background-100 rounded-lg p-4 border border-background-200/70 group-hover:border-primary-200 transition-colors">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="inline-block px-2 py-0.5 bg-secondary-100 text-secondary-700 text-[11px] font-semibold rounded whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}